
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/spotify-isnt-legal-for-your-business",
      function () {
        return require("private-next-pages/articles/spotify-isnt-legal-for-your-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/spotify-isnt-legal-for-your-business"])
      });
    }
  